'use strict';

module.exports = '_sugar_';


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/var/PRIVATE_PROP_PREFIX.js
// module id = 80
// module chunks = 0